export enum TRACK_EVENT {
    PAGE_VIEW = 'page_view',
    ADD_TO_CART = 'add_to_cart',
    BEGIN_CHECKOUT = 'begin_checkout',
    PURCHASE = 'purchase',
    REFUND = 'refund',
    VIEW_CART = 'view_cart',
    VIEW_ITEM = 'view_item',
    VIEW_ITEM_LIST = 'view_item_list',
    SEARCH = 'search',
}

export const GA_TRACK_EVENT_NAME_MAP = {
    [TRACK_EVENT.PAGE_VIEW]: 'page_view',
    [TRACK_EVENT.ADD_TO_CART]: 'add_to_cart',
    [TRACK_EVENT.BEGIN_CHECKOUT]: 'begin_checkout',
    [TRACK_EVENT.PURCHASE]: 'purchase',
    [TRACK_EVENT.REFUND]: 'refund',
    [TRACK_EVENT.VIEW_CART]: 'view_cart',
    [TRACK_EVENT.VIEW_ITEM]: 'view_item',
    [TRACK_EVENT.VIEW_ITEM_LIST]: 'view_item_list',
    [TRACK_EVENT.SEARCH]: 'search',
};

export const FB_PIXEL_TRACK_EVENT_NAME_MAP = {
    [TRACK_EVENT.PAGE_VIEW]: 'ViewContent',
    [TRACK_EVENT.ADD_TO_CART]: 'AddToCart',
    [TRACK_EVENT.BEGIN_CHECKOUT]: 'InitiateCheckout',
    [TRACK_EVENT.PURCHASE]: 'Purchase',
    [TRACK_EVENT.REFUND]: 'Refund',
    [TRACK_EVENT.VIEW_CART]: 'ViewCart',
    [TRACK_EVENT.VIEW_ITEM]: 'ViewItem',
    [TRACK_EVENT.VIEW_ITEM_LIST]: 'ViewItemList',
    [TRACK_EVENT.SEARCH]: 'Search',
};
